import React from 'react';
import {useTranslation} from 'react-i18next';
import {
    FACT_TYPE_MODIFIER, CONFIDENCE_MODIFIER, ORIGIN, DETAIL_LEVEL,
    factTypeLabelKey, confidenceLabelKey, originLabelKey,
} from './factConstants';
import {FactTypeHelp} from './FactTypeHelp';

// Badges de un hecho: tipo + confianza + origen. Cada uno con COLOR + TEXTO (nunca color solo, por
// accesibilidad). El origen distingue IA vs equipo. `hideType` omite el badge de tipo cuando la lista
// ya está agrupada por tipo (biblioteca): el acento del borde izquierdo ya lo comunica. El estado de
// compartido no va como badge acá — lo muestra y controla el toggle de la card.
//
// `leading` es un badge que va PRIMERO, para lo que depende de la lista y no del hecho (hoy: el
// «sin confirmar» de la cola). No se decide acá: el mismo hecho es pendiente en una superficie y ya
// está en la memoria en otra.
export function FactBadges({fact, hideType, leading}) {
    const {t} = useTranslation();
    const isAi = fact.origin === ORIGIN.AI_INFERRED;
    return (
        <div className="cmem-badges">
            {leading}
            {/* El tipo explica QUÉ clase de verdad es este hecho, y no se entiende solo: en el
                piloto, «restricción» hubo que explicarlo a mano (card GcSbgD7B). El badge lleva su
                definición al pasar el mouse. */}
            {/* `-below-left`, igual que la carta del mazo: el default del design system está
                calibrado para un ⓘ de 16px (`left: 25px`) y sobre un badge de ~70px el cartel abre
                ENCIMA de su propio disparador, que es justo la palabra que se está explicando
                (QA-VIS-knob2-10, 27/09). */}
            {!hideType && (
                <FactTypeHelp
                    type={fact.fact_type}
                    placement="-below-left"
                    className={`cmem-badge cmem-type ${FACT_TYPE_MODIFIER[fact.fact_type] || '-other'}`}>
                    {t(factTypeLabelKey(fact.fact_type))}
                </FactTypeHelp>
            )}
            <span className={`cmem-badge cmem-confidence ${CONFIDENCE_MODIFIER[fact.confidence] || '-low'}`}>
                {t(confidenceLabelKey(fact.confidence))}
            </span>
            <span className={`cmem-badge cmem-origin ${isAi ? '-ai' : '-human'}`}>
                {t(originLabelKey(fact.origin))}
            </span>
            {fact.detail_level === DETAIL_LEVEL.PLATFORM && (
                // Nivel de detalle: sólo se señala el detalle de plataforma (lo global es el
                // default y no necesita badge — feedback Barbie: menos densidad).
                <span className="cmem-badge cmem-detail-platform"
                      title={t('client_memory.badge.platform_hint')}>
                    {t('client_memory.detail_level.platform')}
                </span>
            )}
            {fact.is_stale && (
                <span className="cmem-badge cmem-stale" title={t('client_memory.badge.stale_hint')}>
                    {t('client_memory.badge.stale')}
                </span>
            )}
        </div>
    );
}
